import { useContext, useEffect, useRef, useCallback } from 'react';

import './Message.scss';
import { FaCheckCircle, FaExclamationCircle, FaTimesCircle } from 'react-icons/fa';

import AppContext from "../../../store/app-context";

function Message() {
    const appCtx = useContext(AppContext);
    const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const typeClasses = [
        'error', 'ok', 'warn'
    ];

    const closeMessage = useCallback(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
        appCtx.newMessage({text: '', type: null});
    }, [appCtx]);

    // Auto-dismiss success (3s) and warning (5s) messages.
    // Errors (type 0) stay until user taps.
    useEffect(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }

        if (appCtx.message.text.length > 0) {
            if (appCtx.message.type === 1) {
                timerRef.current = setTimeout(closeMessage, 3000);
            } else if (appCtx.message.type === 2) {
                timerRef.current = setTimeout(closeMessage, 5000);
            }
        }

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [appCtx.message.text, appCtx.message.type, closeMessage]);

    const messageType = () => {
        if(appCtx.message.type !== null){
            return typeClasses[appCtx.message.type];
        }else{
            return '';
        }
    };

    const isVisible = appCtx.message.text.length > 0;
    const isError = appCtx.message.type === 0;

    return (
        <div
            id="message"
            className={
                (isVisible ? '' : 'hide') +
                (isError ? ' blocking' : ' toast')
            }
        >
            {/* Backdrop only for errors (require user acknowledgment) */}
            {isError && <div className="backdrop" onClick={closeMessage} />}
            <div className={'inner ' + messageType()} onClick={closeMessage} >
                <section className="modal">
                    <span>
                        {appCtx.message.text}
                    </span>
                    {appCtx.message.type === 1 && <FaCheckCircle className=""/>}
                    {appCtx.message.type === 2 && <FaExclamationCircle className=""/>}
                    {appCtx.message.type === 0 && <FaTimesCircle className=""/>}
                </section>
            </div>
        </div>
    );
}

export default Message;
